<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
    <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
</div>
<app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
</app-return-methods>
<div class="contentBox" (window:resize)="onResize()">
    <div class="center col-3">
        <div class="info-logo-container">
            <img src="{{ info.logo }}" class="payment_method_no_interactive __method_brands" alt="Logo claroPay" />
        </div>
    </div>
    <div class="col-7">
        <div class="methodInfo">
            <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
            </app-return-methods>
            <h1 class="claroPay-subTitle">{{ 'claroPay-Subtitle' | translation | async }}</h1>
            <p class="claroPay-description">{{ 'claroPay-Description' | translation | async }}</p>

            <div class="claroPay-container" *ngIf="isMobileDevice else web_device">
                <p innerHTML="{{ 'html-important' | translation | async }}"></p>
                <p innerHTML="{{ 'claroPay-Step-One-Mobile' | translation | async }}"></p>
            </div>
            <ng-template #web_device class="claroPay-container">
                <app-counter-item [number]="1">
                    <p innerHTML="{{ 'claroPay-Step-Two-Web' | translation | async }}">
                    </p>
                </app-counter-item>

                <app-counter-item [number]="2">
                    <p innerHTML="{{ 'claroPay-Step-Three' | translation | async }}"></p>
                    <canvas id="canvas"></canvas>
                </app-counter-item>

                <p class="claroPay-description" innerHTML="{{ 'claroPay-Step-One-Web' | translation | async }}"></p>

            </ng-template>

        </div>
        <app-buttons-bar (CUSTOM)="validateClaroSteps()" [template]="template" [nameCustom]="'Continuar'"
            [valid]="true" >
        </app-buttons-bar>
    </div>
</div>